import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import { IModelService } from 'vscode/vscode/vs/editor/common/services/model';
import { ResourceMap } from 'vscode/vscode/vs/base/common/map';
import { DisposableStore } from 'vscode/vscode/vs/base/common/lifecycle';
import { Emitter } from 'vscode/vscode/vs/base/common/event';
import { ResourceTextEdit, ResourceFileEdit } from 'vscode/vscode/vs/editor/browser/services/bulkEditService';
import { ResourceNotebookCellEdit } from 'vscode/vscode/vs/workbench/contrib/bulkEdit/browser/bulkCellEdits';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';

let ConflictDetector = class ConflictDetector {
    constructor(edits, fileService, modelService, logService) {
        this._conflicts = ( new ResourceMap());
        this._disposables = ( new DisposableStore());
        this._onDidConflict = ( new Emitter());
        this.onDidConflict = this._onDidConflict.event;
        const _workspaceEditResources = ( new ResourceMap());
        for (const edit of edits) {
            if (edit instanceof ResourceTextEdit) {
                _workspaceEditResources.set(edit.resource, true);
                if (typeof edit.versionId === 'number') {
                    const model = modelService.getModel(edit.resource);
                    if (model && model.getVersionId() !== edit.versionId) {
                        this._conflicts.set(edit.resource, true);
                        this._onDidConflict.fire(this);
                    }
                }
            }
            else if (edit instanceof ResourceFileEdit) {
                if (edit.newResource) {
                    _workspaceEditResources.set(edit.newResource, true);
                }
                else if (edit.oldResource) {
                    _workspaceEditResources.set(edit.oldResource, true);
                }
            }
            else if (edit instanceof ResourceNotebookCellEdit) {
                _workspaceEditResources.set(edit.resource, true);
            }
            else {
                logService.warn('UNKNOWN edit type', edit);
            }
        }
        this._disposables.add(fileService.onDidFilesChange(e => {
            for (const uri of ( _workspaceEditResources.keys())) {
                if (!modelService.getModel(uri) && e.contains(uri)) {
                    this._conflicts.set(uri, true);
                    this._onDidConflict.fire(this);
                    break;
                }
            }
        }));
        const onDidChangeModel = (model) => {
            if (( _workspaceEditResources.has(model.uri))) {
                this._conflicts.set(model.uri, true);
                this._onDidConflict.fire(this);
            }
        };
        for (const model of modelService.getModels()) {
            this._disposables.add(model.onDidChangeContent(() => onDidChangeModel(model)));
        }
    }
    dispose() {
        this._disposables.dispose();
        this._onDidConflict.dispose();
    }
    list() {
        return [...( this._conflicts.keys())];
    }
    hasConflicts() {
        return this._conflicts.size > 0;
    }
};
ConflictDetector = ( __decorate([
    ( __param(1, IFileService)),
    ( __param(2, IModelService)),
    ( __param(3, ILogService))
], ConflictDetector));

export { ConflictDetector };
